import { LoginResponseDto } from "../dto/login-response-dto";
import { LoginResponseInfoEntity } from "@/domain/entity/login-response-info-entity";
import { assertLoginResponseDto } from "@/utils/validation";

export class LoginResponseInfoMapper {
  static toEntity(loginResponseDto: LoginResponseDto): LoginResponseInfoEntity {
    // AST 기반 타입 검증
    assertLoginResponseDto(loginResponseDto);
    return {
      isExpiredSn: loginResponseDto.isExpiredSn,
    };
  }
}
